import React from 'react'

export const HeaderTopsvg = () => {
  return (
<svg width="100%" height="98" viewBox="0 0 1277 98" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_496_1530)">
<path d="M912.007 1L4.57568 1.00001C74.3263 1.00011 97.6756 26.4075 119.562 50.2232C138.868 71.2308 157.036 91 204.909 91H1072.09C1119.96 91 1138.13 71.2308 1157.44 50.2232C1179.32 26.4075 1202.67 1.00011 1272.42 1.00001L912.007 1Z" fill="white"/>
</g>
<defs>
<filter id="filter0_d_496_1530" x="0.575684" y="0" width="1275.85" height="98" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="3"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_496_1530"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_496_1530" result="shape"/>
</filter>
</defs>
</svg>
  )
}
